const calendarConfiguration = {
  sameDay: '[Today at] h:mm A',
  lastDay: '[Yesterday at] h:mm A',
  sameElse: 'DD MMM YYYY [at] h:mm A',
};

export default calendarConfiguration;
